import { Component, OnDestroy, OnInit } from '@angular/core';
import { NotificationCenterMessageType, NotificationCenterMessageView, NotificationCenterService } from '@fgb/core';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NotificationCenterToastComponent } from '../toast/notification-center-toast';

/**
 * Handles notification toast messages using the notificationReceived observable
 * Should only be implemented once otherwise it'll duplicate toasts
 */
@Component({
  selector: 'fgb-notification-toast',
  templateUrl: './notification-toast.component.html',
})
export class NotificationToastComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject();
  constructor(private toastrService: ToastrService, private notificationService: NotificationCenterService) {}

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  ngOnInit(): void {
    this.notificationService.notificationReceived$.pipe(takeUntil(this._destroyed$)).subscribe((notification) => {
      switch (notification.messageType) {
        case NotificationCenterMessageType.Toast:
        case NotificationCenterMessageType.PersistentToast:
          this.createToastNotification(notification);
          break;
      }
    });
  }

  createToastNotification(notification: NotificationCenterMessageView) {
    const toast = this.toastrService.show('', '', {
      toastComponent: NotificationCenterToastComponent,
      disableTimeOut: notification.messageType === NotificationCenterMessageType.PersistentToast,
      closeButton: true,
      tapToDismiss: false,
    });

    if (toast.toastRef && toast.toastRef.componentInstance) {
      toast.toastRef.componentInstance.notification = notification;
    }
  }
}
